/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-08-23T17:52:38+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import ScaleInChild from './ScaleInChild';

class ScaleIn extends Component {
  render() {
    const {
      children,
      childStyle,
      maxScale,
      minScale,
      style,
      ...other
    } = this.props;

    const mergedRootStyles = Object.assign({}, {
      position: 'relative',
      overflow: 'hidden',
    }, style);

    const newChildren = React.Children.map(children, (child) => {
      return (
        <ScaleInChild
          key={child.key}
          maxScale={maxScale}
          minScale={minScale}
          style={childStyle}
        >
          {child}
        </ScaleInChild>
      );
    });

    return (
      <TransitionGroup
        {...other}
        style={mergedRootStyles}
      >
        {newChildren}
      </TransitionGroup>
    );
  }
}


ScaleIn.propTypes = {
  childStyle: PropTypes.object,
  children: PropTypes.node,
  maxScale: PropTypes.number,
  minScale: PropTypes.number,
  style: PropTypes.object,
};
ScaleIn.defaultProps = {
  maxScale: 100,
  minScale: 10,
};

export default ScaleIn;

